/**
 * Конфигурация пунктов меню навбара.
 * Поле iconKey — ключ для подстановки компонента иконки из Navbar (см. NAV_ICONS).
 */
import { hasRouteAccess } from './routes';
export const NAV_ICON_KEYS = {
  HOME: 'HomeIcon',
  BUILD: 'BuildIcon',
  REQUEST: 'RequestIcon',
  SALES: 'SalesIcon',
  SHOPPING_CART: 'ShoppingCartIcon',
  DESCRIPTION: 'DescriptionIcon',
  CREATE: 'CreateIcon',
  LIBRARY: 'LibraryBooksIcon',
  REPORTS: 'ReportsIcon',
  PERSON: 'PersonIcon',
  CATEGORY: 'CategoryIcon',
  PHONE_ANDROID: 'PhoneAndroidIcon',
  LOCAL_SHIPPING: 'LocalShippingIcon',
  MENU_BOOK: 'MenuBookIcon',
  REPLAY: 'ReplayIcon',
  SETTINGS: 'SettingsIcon',
};

/** Доступ к пункту меню: тип профиля + опционально permission. */
export function canAccessNavSubItem(user, subItem) {
  if (!user?.profile_type_code || !subItem?.path) return false;
  if (!hasRouteAccess(subItem.path, user.profile_type_code)) return false;
  if (subItem.permission) {
    const codes = user.permission_codes || [];
    if (!codes.includes(subItem.permission)) return false;
  }
  return true;
}

export function buildNavMenuItems(iconMap) {
  const I = NAV_ICON_KEYS;
  const customerMenuItems = [
    { title: 'Ремонты', path: '/repairs', iconKey: I.BUILD },
    { title: 'Заказы', path: '/customer-orders', iconKey: I.LOCAL_SHIPPING }
  ].map((item) => ({ ...item, icon: iconMap[item.iconKey] }));

  const standardMenuItems = [
    {
      title: 'Основное',
      items: [
        { title: 'Главная', path: '/', iconKey: I.HOME },
        { title: 'Ремонты', path: '/repairs/current', iconKey: I.BUILD },
        { title: 'Внутренние заказы', path: '/orders', iconKey: I.SHOPPING_CART },
        { title: 'Внешние закупки', path: '/comings', iconKey: I.REQUEST },
        { title: 'Заказы клиентов', path: '/customer-orders', iconKey: I.LOCAL_SHIPPING },
        { title: 'Продажи', path: '/sales', iconKey: I.SALES },
        { title: 'Возвраты', path: '/returns', iconKey: I.REPLAY },
        { title: 'Документы', path: '/documents', iconKey: I.DESCRIPTION }
      ].map((item) => ({ ...item, icon: iconMap[item.iconKey] }))
    },
    {
      title: 'Создать',
      iconKey: I.CREATE,
      submenu: [
        { title: 'Ремонт', path: '/repairs/new', iconKey: I.BUILD },
        { title: 'Внутренний заказ', path: '/orders/new', iconKey: I.SHOPPING_CART },
        { title: 'Внешнюю закупку', path: '/comings/new', iconKey: I.REQUEST },
        { title: 'Заказ клиента', path: '/customer-orders/new', iconKey: I.LOCAL_SHIPPING },
        { title: 'Продажу', path: '/sales/new', iconKey: I.SALES },
        { title: 'Возврат', path: '/returns/new', iconKey: I.REPLAY }
      ].map((item) => ({ ...item, icon: iconMap[item.iconKey] }))
    },
    {
      title: 'Операции',
      iconKey: I.BUILD,
      submenu: [
        { title: 'Ремонты', path: '/repairs', iconKey: I.BUILD },
        { title: 'Внутренние заказы', path: '/orders', iconKey: I.SHOPPING_CART },
        { title: 'Внешние закупки', path: '/comings', iconKey: I.SHOPPING_CART },
        { title: 'Заказы клиентов', path: '/customer-orders', iconKey: I.LOCAL_SHIPPING },
        { title: 'Продажи', path: '/sales', iconKey: I.SALES },
        { title: 'Возвраты', path: '/returns', iconKey: I.REPLAY }
      ].map((item) => ({ ...item, icon: iconMap[item.iconKey] }))
    },
    {
      title: 'Документы',
      iconKey: I.DESCRIPTION,
      submenu: [
        { title: 'База знаний', path: '/documents', iconKey: I.MENU_BOOK }
      ].map((item) => ({ ...item, icon: iconMap[item.iconKey] }))
    },
    {
      title: 'Справочники',
      iconKey: I.LIBRARY,
      submenu: [
        { title: 'Профили', path: '/profiles', iconKey: I.PERSON },
        { title: 'Дедупликация клиентов', path: '/profiles/dedup', iconKey: I.PERSON },
        { title: 'Работы и запчасти', path: '/references/categories', iconKey: I.CATEGORY },
        { title: 'Модели', path: '/references/models', iconKey: I.PHONE_ANDROID }
      ].map((item) => ({ ...item, icon: iconMap[item.iconKey] }))
    },
    {
      title: 'Отчеты',
      iconKey: I.REPORTS,
      submenu: [
        { title: 'Все отчеты', path: '/reports', iconKey: I.REPORTS },
        { title: 'Закрытые периоды', path: '/reports/list', iconKey: I.REPORTS }
      ].map((item) => ({ ...item, icon: iconMap[item.iconKey] }))
    },
    {
      title: 'Сервис',
      iconKey: I.SETTINGS,
      submenu: [
        {
          title: 'Системная консоль',
          path: '/admin/system',
          iconKey: I.SETTINGS,
          permission: 'system_console',
        },
      ].map((item) => ({ ...item, icon: iconMap[item.iconKey] })),
    },
  ].map((section) => ({
    ...section,
    icon: section.iconKey ? iconMap[section.iconKey] : undefined
  }));

  return { customerMenuItems, standardMenuItems };
}
